// extracted by mini-css-extract-plugin
export default {"resultsPage":"IL0R9v","noInsights":"JsEvRx","centeredContent":"T9MDwv","narrowContent":"uEG5hF","sidePanel":"zLnEfX"};